import { setAppQuery } from '@src/public/utils/url';
import { linkAnalyze } from './service';
import { linkType } from './contants';
import { Grounds } from '@ifeng-fe/client_grounds';

export const generateUcmsLink = (type, base62) => {
    switch (type) {
        case 'slide':
            return `https://nine.ifeng.com/GetNewsDocs?aid=ucms_${base62}`;
        case 'special':
            return `https://nine.ifeng.com/newTopic?topicid=${base62}&json=y`;
        case 'hotEvent':
            return `https://nine.ifeng.com/hotSpotDetailList?eventName=${base62}`;
        default:
            return `ucms_${base62}`;
    }
};

export const groundsDispatch = async ({ to, type, needLinkAnalyze, timelineId }) => {
    // to:地址, type：默认web, needLinkAnalyze :不传为false（后端解析）, 跳转ref统计值
    let dispatchUrl = to;
    let dispatchType = type;

    // 如果类型为web且需要解析链接
    if (dispatchType === 'web' && needLinkAnalyze) {
        try {
            // 如果链接无协议头则添加
            const link = dispatchUrl.startsWith('http') ? dispatchUrl : `http://${dispatchUrl}`;
            // 请求解析链接接口
            const res = await linkAnalyze(link);
            const { code, data } = res;

            if (code === 0 && data) {
                // 成功解析的情况，outLinkType为1为原生类型，为2为安全链接，此处只用到为1的情况
                const { outLinkType, doc, base62 } = data;

                if (outLinkType === 1 && doc) {
                    const { type: ucmsType } = doc;

                    if (linkType[ucmsType]) {
                        dispatchUrl = generateUcmsLink(ucmsType, base62);
                        dispatchType = linkType[ucmsType];
                    }
                }
            }
        } catch (e) {
            console.error(e);
        }
    }

    // setAppQuery:端内URL声明（如沉浸式?immersion=true）
    if (dispatchType === 'web') {
        dispatchUrl = setAppQuery(dispatchUrl);
    }

    Grounds.dispatch({
        link: {
            type: dispatchType,
            url: dispatchUrl,
        },
        pageLogParams: {
            ref: (timelineId && `timeline_${timelineId}`) || '',
        },
    });
};
